import React, { useState } from 'react'
import ReactTable from 'react-table'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { reduxForm, getFormValues, Field, SubmissionError } from 'redux-form'
import { Segment, Header, Icon, Button, Popup, Confirm, Sidebar, Container } from 'semantic-ui-react'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getOptionTitle } from 'core/utilities'
import { showModal } from 'ducks/app'
import { getCompanies, getAssets } from 'ducks/options'
import { getMappingWbsAssets, setFormWbsAsset, 
  createMappingWbsAsset, updateMappingWbsAsset,
  deleteMappingWbsAsset, getAssetTypes, getAllWbs } from 'ducks/mappingData'

import r from 'reactotron-react-js'

const columns = (props) => [
  {
    Header: 
      <div style={{ display: 'flex', width: '100%' }}>
        <Button content='Add' icon='plus' color='blue' basic onClick={() => props.setShowForm(true) } />
      </div>,
    columns: [
      {
        Header: 'Actions',
        accessor: '',
        headerStyle: { fontWeight: 'bold' },
        width: 90,
        resizable: false,
        Cell: row => (
          <div className='actionsContent'>
            <Popup 
              content='Edit' 
              trigger={
                <Button 
                  className='clear' 
                  icon='pencil' 
                  circular 
                  type='button' 
                  onClick={() => {
                    props.setFormWbsAsset({ ...row.original })
                    props.setShowForm(true)
                    props.setEditMode(true)
                  }} />
              } />
            <Popup 
              content='Remove' 
              trigger={
                <Button 
                  circular 
                  icon='trash' 
                  type='button' 
                  className='clear' 
                  onClick={() => {
                    props.setDeleteId(row.original.id)
                    props.setDeleteMessage(
                      `Are you sure to remove mapping data 
                      ${getOptionTitle(props.wbsOptions, row.original.wbsElementCode)} <-> 
                      ${getOptionTitle(props.assetOptions, row.original.assetCode)} ?`
                    )
                    props.setShowConfirmDelete(true)
                  }} />
              } />
          </div>
        )
      }, {
        Header: 'Active',
        accessor: 'active',
        width: 50,
        Cell: row => <Icon name={row.value ? 'check' : 'remove' } color={row.value ? 'green' : 'red'} /> 
      }, {
        Header: 'WBS',
        accessor: 'wbsElementCode',
        Cell: row =>
          <React.Fragment>
            {getOptionTitle(props.wbsOptions, row.value)} 
            {props.wbsElementsLoading ? <Icon style={{ marginLeft: '5px' }} name='spinner' loading /> : null}
          </React.Fragment>,
      }, {
        Header: 'Asset',
        accessor: 'assetCode',
        Cell: row => 
          <React.Fragment>
            {getOptionTitle(props.assetOptions, row.value)} 
            {props.assetLoading ? <Icon style={{ marginLeft: '5px' }} name='spinner' loading /> : null}
          </React.Fragment>,
      }, {
        Header: 'Asset Type',
        accessor: 'assetType',
        width: 90,
      }
    ]
  }
]

const MappingWbsAsset = (props) => {
  const { handleSubmit, wbsAssets, valueForm, change,
    showModal, setFormWbsAsset, createMappingWbsAsset, 
    updateMappingWbsAsset, deleteMappingWbsAsset, 
    wbsElements, wbsElementsLoading, assetOptions, assetLoading, 
    assetTypeOptions, assetTypeLoading, companyOptions, companyLoading } = props

  const [showForm, setShowForm] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [showConfirmDelete, setShowConfirmDelete] = useState(false)
  const [deleteId, setDeleteId] = useState(0)
  const [deleteMessage, setDeleteMessage] = useState('')
  
  const onSubmitData = (values)=> {
    const onSuccess = () => {
      setShowForm(false)
      setEditMode(false)
      setFormWbsAsset()
    }

    const submitData = () => {
      if (editMode) {
        updateMappingWbsAsset(values, onSuccess)
      } else {
        createMappingWbsAsset(values, onSuccess)
      }
    }

    const onDataDuplicate = (header, message) => {
      showModal(true, header, message)
      throw new SubmissionError('error.validationErrors')
    }

    const validateAssetType = () => {
      let findDuplicateAsset = wbsAssets.find(w => 
        w.assetCode === values.assetCode &&
        w.assetType === values.assetType &&
        w.company === values.company
      )

      if (findDuplicateAsset) {
        if (editMode) {
          if (values.id !== findDuplicateAsset.id) {
            onDataDuplicate('This Asset and Asset Type has already mapping under this company.', 'Please select another Asset or Asset Type or remove current mapped data.')
          } else {
            submitData()
          }
        } else {
          onDataDuplicate('This Asset and Asset Type has already mapping under this company.', 'Please select another Asset or Asset Type or remove current mapped data.')
        }
      } else {
        submitData()
      }
    }

    let findDuplicateWbs = wbsAssets.find(w => 
      w.wbsElementCode === values.wbsElementCode &&
      w.assetCode === values.assetCode
    )
    if (findDuplicateWbs) {
      if (editMode) {
        if (values.id !== findDuplicateWbs.id) {
          onDataDuplicate('This WBS has already mapping.', 'Please select another WBS or remove current mapped data.')
        } else {
          validateAssetType()
        }
      } else {
        onDataDuplicate('This WBS has already mapping.', 'Please select another WBS or remove current mapped data.')
      }
    } else {
      validateAssetType()
    }
  }

  const filterWbsByCompany = (company) => {
    let wbs = company ? wbsElements.filter(w => w.companyCode === company) : [] //wbsElements 
    return wbs.map(w => ({ value: w.wbsElementCode, text: w.wbsElementCode + ' : ' + w.name }))
  }

  const filterAssetByCompany = (company) => {
    return company ? assetOptions.filter(w => w.companyCode === company) : [] //assetOptions
  }

  return (
    <Sidebar.Pushable as={Container}>
      <Sidebar
        as={Segment}
        animation='overlay'
        direction='top'
        visible={showForm}
      >
        <form onSubmit={handleSubmit(onSubmitData)} >
          <Field 
            require 
            name='company' 
            label='Company'
            loading={companyLoading} 
            options={companyOptions} 
            type={type.select}
            specialOnChange={() => {
              change('wbsElementCode', '')
              change('assetCode', '')
            }}
            component={FieldInput} />
          <Field 
            require 
            name='wbsElementCode' 
            label='WBS'
            placeHolder={valueForm.company ? '' : 'Please select company first.'}
            loading={wbsElementsLoading} 
            options={filterWbsByCompany(valueForm.company)} 
            type={type.select} 
            component={FieldInput} />
          <Field 
            require 
            name='assetCode' 
            label='Asset' 
            placeHolder={valueForm.company ? '' : 'Please select company first.'}
            loading={assetLoading} 
            options={filterAssetByCompany(valueForm.company)} 
            type={type.select} 
            component={FieldInput} />
          <Field 
            require 
            name='assetType' 
            label='Asset Type' 
            loading={assetTypeLoading} 
            options={assetTypeOptions} 
            type={type.select} 
            component={FieldInput} />
          <Field name='active' label='Active' type={type.switch} component={FieldInput} />
          <Button type='submit' color='blue' content={editMode ? 'Update' : 'Add'}  />
          <Button type='button' color='red' content='Cancel' 
            onClick={() => {
              setShowForm(false)
              setEditMode(false)
              setFormWbsAsset()
              props.reset('formOrderGl')
            }} />
        </form>
      </Sidebar>
      <Sidebar.Pusher>
        {wbsAssets ? 
          <ReactTable 
            columns={
              columns({
                setShowForm, setEditMode, setFormWbsAsset, 
                wbsOptions: wbsElements.map(w => ({ value: w.wbsElementCode, text: w.wbsElementCode + ' : ' + w.name })), 
                wbsElementsLoading, assetOptions, assetLoading,
                setShowConfirmDelete, setDeleteId, setDeleteMessage })} 
            data={wbsAssets} 
            minRows={5}/> :
          <Segment placeholder>
            <Header icon>
              <Icon name='file outline' />
              {'No mapping data'}
              <br />
              {'WBS <-> Asset.'}
            </Header>
            <Button primary>Add Data</Button>
          </Segment>
        }
      </Sidebar.Pusher>
      <Confirm 
        open={showConfirmDelete}
        header='Are you sure to remove?'
        content={deleteMessage}
        confirmButton='Remove'
        onCancel={() => {
          setShowConfirmDelete(false)
          setDeleteId(0)
          setDeleteMessage('')
        }}
        onConfirm={() => {
          deleteMappingWbsAsset(deleteId, () => {
            setShowConfirmDelete(false)
            setDeleteId(0)
            setDeleteMessage('')
          })
        }}
      />
    </Sidebar.Pushable>
  )
}

const mapStateToProps = (state) => ({
  valueForm: getFormValues('formWbsAsset')(state) || {},
  initialValues: {
    ...state.mappingData.formWbsAsset
  },
  wbsAssets: state.mappingData.allWbsAssets.data,
  companyOptions: state.options.companies.data,
  companyLoading: state.options.companies.loading,
  assetOptions: state.options.assets.data,
  assetLoading: state.options.assets.loading,
  assetTypeOptions: state.mappingData.assetTypes.data,
  assetTypeLoading: state.mappingData.assetTypes.loading,
  wbsElements: state.mappingData.allWbs.data,
  wbsElementsLoading: state.mappingData.allWbs.loading,
})

const mapDispatchToProps = {
  getMappingWbsAssets,
  setFormWbsAsset,
  createMappingWbsAsset, 
  updateMappingWbsAsset,
  deleteMappingWbsAsset,
  getAssetTypes,
  getCompanies,
  getAssets,
  getAllWbs,
  showModal,
}

const validate = values => {
  const errors = {}

  if(!values.wbsElementCode) {
    errors.wbsElementCode = 'Required!'
  }

  if(!values.assetCode) {
    errors.assetCode = 'Required!'
  }

  if(!values.assetType) {
    errors.assetType = 'Required!'
  }

  return errors
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formWbsAsset',
    enableReinitialize: true,
    validate,
  }),
  lifecycle({
    componentDidMount() { 
      if (!this.props.wbsAssets.length) {
        this.props.getMappingWbsAssets(true)
      }

      if (!this.props.assetTypeOptions.length) {
        this.props.getAssetTypes(true)
      }

      if (!this.props.assetOptions.length) {
        this.props.getAssets()
      }

      if (!this.props.companyOptions.length) {
        this.props.getCompanies()
      }

      if (!this.props.wbsElements.length) {
        this.props.getAllWbs()
      }
    },
    componentWillReceiveProps(nextProp) { }
  })
)

export default enhance(MappingWbsAsset)